"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoType = exports.Action = void 0;
var Action;
(function (Action) {
    Action["UserJoin"] = "User Join";
    Action["UserExit"] = "User Exit";
    Action["FloorJoin"] = "Joined Floor";
    Action["HuddleCreated"] = "Huddle Created";
    Action["HuddleDisbanded"] = "Huddle Disbanded";
    Action["UserJoinedHuddle"] = "User Joined Huddle";
    Action["UserLeftHuddle"] = "User Left Huddle";
    Action["BoothHuddleCreated"] = "Booth Huddle Created";
    Action["BoothHuddleDisbanded"] = "Booth Huddle Disbanded";
    Action["UserJoinedBoothHuddle"] = "User Joined Booth Huddle";
    Action["UserLeftBoothHuddle"] = "User Left Booth Huddle";
    Action["UserVisitBooth"] = "User Visit Booth";
    Action["UserLeftBooth"] = "User Left Booth";
    Action["PhotoTaken"] = "Photo Taken";
})(Action = exports.Action || (exports.Action = {}));
var PhotoType;
(function (PhotoType) {
    PhotoType["Selfie"] = "selfie";
    PhotoType["Group"] = "group";
})(PhotoType = exports.PhotoType || (exports.PhotoType = {}));
